import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import * as graphql from '@treams/treams-network';
import { FlexGap, Heading3, Spinner, tokens } from '@treams/treams-ui';

import FeedbackComposerGoalCard from './FeedbackComposerGoalCard';

export default function FeedbackComposerGoals(props: {
	userID: string;
	goals: { goalID: string; text?: string; order: number }[];
	onChange: (goals: { goalID: string; text?: string; order: number }[]) => void;
}) {
	const { t } = useTranslation();

	const active = graphql.useIndividualGoalsQuery({
		variables: {
			id: props.userID,
			status: graphql.GoalStatus.Active,
			last: 10,
		},
	});

	const completed = graphql.useIndividualGoalsQuery({
		variables: {
			id: props.userID,
			status: graphql.GoalStatus.Completed,
			last: 10,
		},
	});

	return (
		<FlexGap flexDirection="column" gap={tokens.gap.section}>
			<FlexGap flexDirection="column" gap={tokens.gap.list}>
				<Heading3>{t('feedback.composer.goals.title')}</Heading3>
				{active.data ? (
					<FlexGap flexDirection="column" gap={tokens.gap.list}>
						{_.sortBy(active.data.user.goalsV2.edges, ({ node: goal }) => -goal.order).map(
							({ node: goal }) => (
								<FeedbackComposerGoalCard
									key={goal.id}
									goal={goal as graphql.Goal}
									text={props.goals.find(({ goalID }) => goal.id === goalID)?.text}
									selected={props.goals.some(({ goalID }) => goal.id === goalID)}
									onChange={(selected, text) => {
										const goals = props.goals.filter(({ goalID }) => goalID !== goal.id);

										if (selected) {
											goals.push({ goalID: goal.id, text, order: goal.order });
										}

										props.onChange(_.sortBy(goals, (goal) => -goal.order));
									}}
								/>
							),
						)}
					</FlexGap>
				) : (
					<Spinner centered />
				)}
			</FlexGap>
			<FlexGap flexDirection="column" gap={tokens.gap.list}>
				<Heading3>{t('feedback.composer.goals.completed')}</Heading3>
				{completed.data ? (
					<FlexGap flexDirection="column" gap={tokens.gap.list}>
						{_.sortBy(completed.data.user.goalsV2.edges, ({ node: goal }) => -goal.order).map(
							({ node: goal }) => (
								<FeedbackComposerGoalCard
									key={goal.id}
									goal={goal as graphql.Goal}
									text={props.goals.find(({ goalID }) => goal.id === goalID)?.text}
									selected={props.goals.some(({ goalID }) => goal.id === goalID)}
									onChange={(selected, text) => {
										const goals = props.goals.filter(({ goalID }) => goalID !== goal.id);

										if (selected) {
											goals.push({ goalID: goal.id, text, order: goal.order });
										}

										props.onChange(_.sortBy(goals, (goal) => -goal.order));
									}}
								/>
							),
						)}
					</FlexGap>
				) : (
					<Spinner centered />
				)}
			</FlexGap>
		</FlexGap>
	);
}
